{
  "cms.order.announce.dropped": "Kohde {title} pudotettiin.",
  "cms.order.announce.movedTo": "Kohde {title} siirrettiin sijalle {position} / {total}.",
  "cms.order.announce.cancelled": "Kohteen {title} siirto peruttiin.",
  "cms.order.announce.pickedUp": "Kohde {title} nostettiin. Käytä nuolinäppäimiä siirtääksesi, välilyönti pudottaa.",
  "cms.order.announce.instructions": "Nosta kohde välilyönnillä, siirrä nuolinäppäimillä, pudota välilyönnillä tai peruuta Esc-näppäimellä.",
  "cms.order.handle.label": "Järjestä: {title}",
  "cms.order.editTrigger": "Muokkaa järjestystä",
  "cms.order.pendingBadge": "Järjestys muuttuu (luonnoksissa)",
  "cms.order.sectionTitle": "Järjestys: {scope}",
  "cms.order.sectionHint": "Vedä kohteet haluamaasi järjestykseen. Muutos näkyy jäsenille vasta julkaisun jälkeen.",
  "cms.order.wasAt": "(oli {position}.)",
  "cms.order.publish": "Julkaise järjestys",
  "cms.order.publishing": "Julkaistaan…",
  "cms.order.discard": "Hylkää järjestysmuutos",
  "cms.order.discarding": "Hylätään…",
  "cms.order.stageError": "Järjestyksen tallennus epäonnistui. Yritä uudelleen.",
  "cms.order.publishError": "Järjestyksen julkaisu epäonnistui. Yritä uudelleen.",
  "cms.order.discardError": "Järjestysmuutoksen hylkääminen epäonnistui. Yritä uudelleen."
}
